module.exports = __webpack_public_path__ + "img/img1.67779f1a.png";